// extracted by mini-css-extract-plugin
module.exports = {"EditableTag":"EditableTag_EditableTag__yo6_N"};